import LandRoverWebBold from '@/assets/fonts/families/land-rover-web/LandRoverWeb-Bold.landrover';
import LandRoverWebDemi from '@/assets/fonts/families/land-rover-web/LandRoverWeb-Demi.landrover';
import LandRoverWebLight from '@/assets/fonts/families/land-rover-web/LandRoverWeb-Light.landrover';
import LandRoverWebMedium from '@/assets/fonts/families/land-rover-web/LandRoverWeb-Medium.landrover';

const landRoverWebFonts = [
	LandRoverWebBold,
	LandRoverWebDemi,
	LandRoverWebLight,
	LandRoverWebMedium,
];

export default landRoverWebFonts;
